<atx-aside-menu
  rootClass="inbound-details-aside-panel"
  backdropClass="cdk-overlay-transparent-backdrop"
  [open]="showDetails"
  [useOverlay]="true"
  [disposeOnNavigation]="true"
  placement="right"
  (openStateChange)="handleClose($event)"
>
  <div
    class="menu-title d-flex align-items-center px-md-4 py-md-3 px-3 py-2 justify-content-between"
  >
    <h4
      class="m-0 font-weight-normal"
      i18n="ConfigStrip|Inbound details header@@inboundDetailsHeader"
    >
      Inbound Details
    </h4>
    <button class="btn btn-round ml-3 p-0" (click)="handleClose(false)">
      <fa-icon [icon]="['fas', 'xmark']" size="lg"></fa-icon>
    </button>
  </div>
  <div class="menu-content h-100 px-md-4 py-md-3 px-3 py-2">
    @if ({ locale: locale$ | async }; as ctx) { @if (loading$ | async) {
    <atx-loader-overlay type="static"></atx-loader-overlay>
    } @else { @if (hasItems$ | async) {
    <div class="row mb-3 detail-row d-md-flex d-none">
      <div class="col-12 col-md-2 pl-0 mb-2">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title m-0"
            i18n="
              ConfigStrip|Inbound details Delivery Date
              header@@inboundDetailsDeliveryDateHeader"
          >
            DELIVERY DATE
          </dt>
        </dl>
      </div>
      <div class="col-12 col-md-4 mb-2">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title m-0"
            i18n="
              ConfigStrip|Inbound details assortment
              header@@inboundDetailsAssortmentHeader"
          >
            ASSORTMENT
          </dt>
        </dl>
      </div>
      <div class="col-12 col-md-2 mb-2">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title m-0"
            i18n="
              ConfigStrip|Inbound details quantity
              header@@inboundDetailsQuantityHeader"
          >
            QUANTITY
          </dt>
        </dl>
      </div>
      <div class="col-12 col-md-2 mb-2">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title m-0"
            i18n="
              ConfigStrip|Inbound details address
              header@@inboundDetailsAddressHeader"
          >
            ADDRESS
          </dt>
        </dl>
      </div>
      <div class="col-12 col-md-2 pr-0 mb-2">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title m-0"
            i18n="
              ConfigStrip|Inbound details order number
              header@@inboundDetailsOrderNumberHeader"
          >
            ORDER NUMBER
          </dt>
        </dl>
      </div>
    </div>
    @if ((inboundHistory$ | async)?.length) {
    <h5
      i18n="
        ConfigStrip|Inbound details Future title
        header@@inboundDetailsFutureTitle"
    >
      Future
    </h5>
    @for (item of inboundHistory$ | async; track item) {
    <div class="row mb-3 detail-row">
      <ng-container
        *ngTemplateOutlet="dabRecord; context: { item: item }"
      ></ng-container>
    </div>
    } } @if ((deliveredHistory$ | async)?.length) {
    <h5
      i18n="
        ConfigStrip|Inbound details Past title header@@inboundDetailsPastTitle"
    >
      Past
    </h5>
    @for (item of deliveredHistory$ | async; track item) {
    <div class="row mb-3 detail-row">
      <ng-container
        *ngTemplateOutlet="dabRecord; context: { item: item }"
      ></ng-container>
    </div>
    } } } @else {
    <atx-empty-placeholder class="empty-placeholder" [icon]="['fas', 'list']">
      <ng-container
        title
        i18n="
          ConfigStrip|Inbound details no data title@@inboundDetailsNodataTitle"
      >
        No data to show
      </ng-container>
      <ng-container
        msg
        i18n="
          ConfigStrip|Inbound details no data
          message@@inboundDetailsNodataMessage"
      >
        That’s a bummer! There are no inbound details.
      </ng-container>
    </atx-empty-placeholder>
    }
    <ng-template #dabRecord let-item="item">
      <div class="col-12 col-md-2 mb-3 pl-md-0">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title d-md-none d-block m-0"
            i18n="
              ConfigStrip|Inbound details Delivery Date
              header@@inboundDetailsDeliveryDateHeader"
          >
            DELIVERY DATE
          </dt>
          <dd class="mb-0">
            {{ item.deliveryDate | localeDate: ctx.locale:dateFormat }}
          </dd>
        </dl>
      </div>
      <div class="col-12 col-md-4 mb-3">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title d-md-none d-block m-0"
            i18n="
              ConfigStrip|Inbound details assortment
              header@@inboundDetailsAssortmentHeader"
          >
            ASSORTMENT
          </dt>
          <dd class="mb-0">{{ item.title }}</dd>
        </dl>
      </div>
      <div class="col-12 col-md-2 mb-3">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title d-md-none d-block m-0"
            i18n="
              ConfigStrip|Inbound details quantity
              header@@inboundDetailsQuantityHeader"
          >
            QUANTITY
          </dt>
          <dd class="mb-0">{{ item.quantity }}</dd>
        </dl>
      </div>
      <div class="col-12 col-md-2 mb-3">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title d-md-none d-block m-0"
            i18n="
              ConfigStrip|Inbound details address
              header@@inboundDetailsAddressHeader"
          >
            ADDRESS
          </dt>
          <dd>
            {{
              getFullShipToAddress(item.address, {
                revertAddress: false,
                countryCodePreferred: false
              })
            }}
          </dd>
        </dl>
      </div>
      <div class="col-12 col-md-2 mb-3 pr-md-0">
        <dl class="mb-0">
          <dt
            class="text-muted font-weight-bold text-uppercase detail-section-title d-md-none d-block m-0"
            i18n="
              ConfigStrip|Inbound details order number
              header@@inboundDetailsOrderNumberHeader"
          >
            ORDER NUMBER
          </dt>
          <dd class="mb-0">
            <a
              class="text-body cursor-pointer"
              [href]="item.orderLink"
              target="_blank"
            >
              <u>{{ item.order }}</u>
            </a>
          </dd>
        </dl>
      </div>
      <a
        class="stretched-link d-md-none"
        [href]="item.orderLink"
        target="_blank"
      ></a>
    </ng-template>
    } }
  </div>
</atx-aside-menu>
